import { render, staticRenderFns } from "./MultiLayerBackgroundPublish.vue?vue&type=template&id=605630c2&scoped=true&"
import script from "./MultiLayerBackgroundPublish.vue?vue&type=script&lang=ts&"
export * from "./MultiLayerBackgroundPublish.vue?vue&type=script&lang=ts&"
import style0 from "./MultiLayerBackgroundPublish.vue?vue&type=style&index=0&id=605630c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605630c2",
  null
  
)

export default component.exports